(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bp-product"]) return;
  try {
    
document.querySelectorAll('.product-form').forEach((form) => {
  const feedback = form.querySelector('[data-bp-cart-feedback]');
  if (!feedback || form.dataset.bpCartReady) return;
  form.dataset.bpCartReady = 'true';
  const status = feedback.querySelector('[data-bp-cart-status]');
  const viewCart = feedback.querySelector('[data-bp-view-cart]');
  form.addEventListener('submit', async (event) => {
    if (event.defaultPrevented) return;
    event.preventDefault();
    if (form.dataset.bpCartBusy || !form.reportValidity()) return;
    const buyNow = event.submitter?.name === 'return_to';
    const data = new FormData(form);
    data.delete('return_to');
    const controls = [...form.querySelectorAll('button, select, input')].map((control) => [control, control.disabled]);
    form.dataset.bpCartBusy = 'true';
    form.setAttribute('aria-busy', 'true');
    controls.forEach(([control]) => { control.disabled = true; });
    status.textContent = feedback.dataset.pending;
    try {
      const response = await fetch(form.action.replace(/\/$/, '') + '.js', {
        method: 'POST', headers: { Accept: 'application/json' }, body: data
      });
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || result.message || feedback.dataset.error);
      status.textContent = feedback.dataset.added;
      viewCart.hidden = false;
      try {
        const cartResponse = await fetch(feedback.dataset.cartUrl + '.js', { headers: { Accept: 'application/json' } });
        if (cartResponse.ok) {
          const cart = await cartResponse.json();
          document.querySelectorAll('.cart-link span').forEach((badge) => { badge.textContent = String(cart.item_count); });
        }
      } catch (_) {}
      if (buyNow) window.location.assign(event.submitter.value);
    } catch (error) {
      status.textContent = error.message === 'Failed to fetch' ? feedback.dataset.error : (error.message || feedback.dataset.error);
      viewCart.hidden = false;
    } finally {
      controls.forEach(([control, disabled]) => { control.disabled = disabled; });
      delete form.dataset.bpCartBusy;
      form.removeAttribute('aria-busy');
    }
  });
});

  } catch(e) { console.error(e); }
})();
})();
